import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import api from "../middleware/api";
import rootReducer from "../reducers";
var configureStore = function configureStore(preloadedState) {
  return createStore(rootReducer, preloadedState, applyMiddleware(thunk, api));
};
export default configureStore;